import React from "react";

function RouteError() {
  return (
    <div >
    </div>
  );
}

export default RouteError;
